import React, { useState, useEffect, useContext } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import TollTable from "components/toll/TollTable";
import TollServices from "services/TollServices";
import MainDrawer from "components/drawer/MainDrawer";
import { SidebarContext } from "context/SidebarContext";
import DataWrapper from "./DataWrapper";
import TollDrawer from "components/drawer/TollDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import { FiRefreshCcw } from "react-icons/fi";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";
import NotFound from "components/table/NotFound";
import ExportDataXlsx from "components/common/ExportDataXlsx";

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color: grey;
  padding: 9px 10px;
  margin: unset;
}`;

const Toll = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const isAdmin = adminInfo?.id === 1;
  const { toggleDrawer } = useContext(SidebarContext);
  const { setIsUpdate } = useContext(SidebarContext);
  const { data, loading, error } = useAsync(() => TollServices.getAllTolls());
  const [status, setStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const isDataArray = Array.isArray(data?.data);
  const safeData = isDataArray ? data?.data : [];
  // console.log("toll data form response", safeData);
 
  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "toll" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "toll" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "toll" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "toll" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "toll" && perm.export === 1
      );

  useEffect(() => {
      if (data?.status) {
        setStatus(data.status);
      } else {
        setStatus(false);
      }
    }, [data?.status]);

  const { title, serviceId } = useToggleDrawer();

  const filteredData = safeData?.filter((item) => {
  return (
    item.toll_name?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.state_name?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.city_name?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.latitude?.toString().includes(searchText.toString()) ||
    item.longitude?.toString().includes(searchText.toString()) ||
    item.sedan?.tag_price?.toString().includes(searchText.toString()) ||
    item.suv?.tag_price?.toString().includes(searchText.toString()) ||
    item.tempo_traveller?.tag_price?.toString().includes(searchText.toString())
  );
});
// console.log("data to render table", filteredData);

const csvData = [
  ['SI.No', 'Toll Name', 'State', 'City', 'Latitude', 'Longitude', 'Sedan Tag', 'Sedan Cash', 'Suv Tag', 'Suv Cash', 'Tempo Traveller Tag', 'Tempo Traveller Cash', 'Status'],
  ...(filteredData || []).map(
    (
      {
        toll_name,
        state_name,
        city_name,
        latitude,
        longitude,
        sedan,
        suv,
        tempo_traveller,
        status,
      },
      index
    ) => [
      index + 1,
      toll_name || "-",
      state_name || "-",
      city_name || "-",
      latitude || "-",
      longitude || "-",
      sedan?.tag_price || "-",
      sedan?.cash_price || "-",
      suv?.tag_price || "-",
      suv?.cash_price || "-",
      tempo_traveller?.tag_price || "-",
      tempo_traveller?.cash_price || "-",
      status ? "Active" : "Inactive",
    ]
  ),
];

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          
					<style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            <TollDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white !dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="items-center gap-6 flex">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Quick Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Toll
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    title="toll"
                    exportDataXlsx={csvData}
                    fileNames="Toll List"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </form>
            </CardBody>
          </Card>

          <div className="data-table-container">
            <DataWrapper loading={loading} error={error} status={status}>
              { filteredData.length > 0 ? (
                <TableContainer
                  className="mb-8"
                  style={{
                    maxHeight: "65vh",
                    overflowY: "scroll",
                    scrollbarWidth: "thin",
                  }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                      <tr>
                        <TableCell className="text-center">SI.No</TableCell>
                        <TableCell className="text-center">Toll Name</TableCell>
                        <TableCell className="text-center">State</TableCell>
                        <TableCell className="text-center">City</TableCell>
                        <TableCell className="text-center">Sedan</TableCell>
                        <TableCell className="text-center">Suv</TableCell>
                        <TableCell className="text-center">Tempo Traveller</TableCell>
                        <TableCell className="text-center">Status</TableCell>
                        <TableCell className="text-center">Actions</TableCell>
                      </tr>
                    </TableHeader>

                    <TollTable
                      tolldata={filteredData}
                      hideView={hideView}
                      hideAdd={hideAdd}
                      hideEdit={hideEdit}
                      hideDelete={hideDelete}
                      hideExport={hideExport}
                    />
                  </Table>
                </TableContainer>
              ) : (
                <div
                  className="mb-8 flex items-center justify-center"
                  style={{ minHeight: "65vh" }}
                >
                  <NotFound title="There are no toll." />
                </div>
              )}
            </DataWrapper>
          </div>
        </>
      )}
    </>
  );
};

export default Toll;
